export default __webpack_public_path__ + "static/media/header-cross.5f1df1de.svg";